// extracted by mini-css-extract-plugin
export default {"button":"ReopenButton_button__zgY+k","button_blue":"ReopenButton_button_blue__yXL40"};